import React from 'react';

const CustomerProductInquiry = () => {
  return <div>CustomerProductInquiry</div>
}

export default CustomerProductInquiry;